var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50474 2C2.22279 2 2 2.22312 2 2.50325V19.4967C2 19.7757 2.22447 20 2.50325 20H19.4967C19.7765 20 20 19.7771 20 19.5019V6.49805C20 6.22075 19.7791 6 19.5037 6H12C11.6852 6 11.3889 5.8518 11.2 5.6L8.5 2H2.50474ZM19.5037 4C20.8835 4 22 5.11597 22 6.49805V19.5019C22 20.8828 20.8799 22 19.4967 22H2.50325C1.12029 22 0 20.8807 0 19.4967V2.50325C0 1.11921 1.11756 0 2.50474 0H9C9.31476 0 9.61115 0.148194 9.8 0.4L12.5 4H19.5037Z",
    fill: "#979EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.54bd7e463fb7c736bbed21bd4fd0d4a9.svg";
export { ForwardRef as ReactComponent };